import { takeLatest, call, put } from "redux-saga/effects";
import api from "../../../services/api";
import {
  CREATE_SUGGESTED_COMPETITOR_REQUEST,
  createSuggestedCompetitorSuccess,
  createSuggestedCompetitorFailure,
} from "../actions/suggestedCompetitorActions";
import {
  createSuggestedCompetitor,
  createSuggestedCompetitorNew,
} from "../../../services/accIqService";

function* createSuggestedCompetitorSaga(action) {
  try {
    const {
      user_id,
      user_type,
      client,
      competitor,
      company_id,
      subdimensions,
      ksCompanies,
      industry,
    } = action.payload;

    yield call(
      createSuggestedCompetitorNew,
      user_id,
      user_type,
      client,
      competitor,
      company_id,
      subdimensions,
      ksCompanies,
      industry
    );

    yield put(createSuggestedCompetitorSuccess());
  } catch (error) {
    yield put(
      createSuggestedCompetitorFailure(
        error?.response?.data?.message || "Failed to add competitor"
      )
    );
  }
}

export default function* suggestedCompetitorWatcher() {
  yield takeLatest(
    CREATE_SUGGESTED_COMPETITOR_REQUEST,
    createSuggestedCompetitorSaga
  );
}
